import React, { Component } from 'react';
import Icon from './Icon.js';
import './Svg.scss';
import './Icon.scss';

export default class EditIcon extends Component {
    render () {
        let finalClassName = Icon.buildCssClass(this.props);

        return (
            <svg className={finalClassName} width="32" height="32" viewBox="0 0 28 28">
                <path d="M21.6624 8.25778L23.7424 10.3378C24.089 10.6844 24.089 11.2444 23.7424 11.5911L22.8228 12.5107C22.4323 12.9012 21.7991 12.9012 21.4086 12.5107L19.4895 10.5916C19.0989 10.201 19.0989 9.56786 19.4895 9.17734L20.409 8.25778C20.5779 8.08889 20.8001 8 21.0313 8C21.2624 8 21.4846 8.08 21.6624 8.25778ZM8.29314 20.3738C8.1056 20.5613 8.00024 20.8157 8.00024 21.0809V23.5C8.00024 23.7761 8.2241 24 8.50024 24H10.9194C11.1846 24 11.4389 23.8946 11.6265 23.7071L20.4576 14.876C20.8481 14.4855 20.8481 13.8523 20.4576 13.4618L18.5385 11.5427C18.1479 11.1521 17.5148 11.1521 17.1242 11.5427L8.29314 20.3738ZM10.7422 22.0758C10.6485 22.1696 10.5213 22.2222 10.3887 22.2222H10.278C10.0019 22.2222 9.77802 21.9984 9.77802 21.7222V21.6116C9.77802 21.479 9.8307 21.3518 9.92447 21.258L17.4778 13.7047C17.6731 13.5094 17.9896 13.5094 18.1849 13.7047L18.2956 13.8154C18.4908 14.0106 18.4908 14.3272 18.2956 14.5225L10.7422 22.0758Z"/>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/icon/Edit.js